import script from "./PasswordExpiredView.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordExpiredView.vue?vue&type=script&setup=true&lang=js"

import "./PasswordExpiredView.vue?vue&type=style&index=0&id=7232c6f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7232c6f2"]])

export default __exports__